import { useEffect, useRef, useState } from "react";
import NivoBarchart from "../../../Nivo/Nivo_Barchart";
import NivoLineChart from "../../../Nivo/Nivo_LineChart";
import NivoPieChart from "../../../Nivo/Nivo_Piechart";
import CommonDropdown from "../CommonDropdown";
import RDD from "../Sales/RDD";
import Map from "../../MapContienent";
import { useSelector } from "react-redux";
import StackedBarChart from "../../../ChartsJs/StatckedBar";
import LineChart from "../../../ChartsJs/LineChart";
import {
  downloadPDF,
  printDocument,
} from "../../../ChartsJs/DownlaodExportImage";
import NewContractChart from "./NewContract";
import ExistingContractChart from "./ExistingContract";
import Upselling from "./Upselling";
import RevenueRDD from "./RevenueRDD";
import OverallChart from "./Overall";
import ScheduledDepositschart from "./ScheduledDeposit";
import RevenueDeficitChart from "./RevenueDeficit";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { baseURL } from "../../../Util/axios_helper";
import RevenueMap from "./RevenueMap";

export default function Revenue() {
  const ChartRef = useRef();
  const { RevenuData, selectedMonth, refresh, metrics, year } = useSelector(
    (state) => state.revenue
  );
  const [GeoShow, setGeoShow] = useState(false);
  const [flag, setFlag] = useState(false);

  const [Carddata, setCarddata] = useState({
    NewContract: 0,
    ExistingContract: 0,
    Upselling: 0,
    RDD: 0,
    Overall: 0,
    Sd: 0,
    Deficit: 0,
  });

  useEffect(() => {
    if (RevenuData && RevenuData.CardTable) {
      const NewContract =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "newcontract"
        )?.Count || 0;

      const ExistingContract =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "existingcontract"
        )?.Count || 0;

      const Upselling =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "upselling"
        )?.Count || 0;

      const RDD =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "rdd"
        )?.Count || 0;

      const Overall =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "overall"
        )?.Count || 0;

      const Sd =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "scheduleddeposits"
        )?.Count || 0;

      const Deficit =
        RevenuData.CardTable.find(
          (item) => item.Type.trim().toLowerCase() === "deficit"
        )?.Count || 0;

      setCarddata((prevCarddata) => ({
        ...prevCarddata,
        NewContract: NewContract,
        ExistingContract: ExistingContract,
        Upselling: Upselling,
        RDD: RDD,
        Overall: Overall,
        Sd: Sd,
        Deficit: Deficit,
      }));
    }
  }, [RevenuData]);

  const [reportcolumn, setreportcolumn] = useState({
    Reportflag: false,
    title: "",
    exportFName: "",
    refreshflag: 0,
    reportvalue: "",
    showGroup: true,
    showPeriodGoal: true,
    PaymentDueDate: true,
  });

  const formatNumberUS = (num) => {
    if (num >= 1000000000) {
      // 1 billion or more
      return `$${(num / 1000000000).toFixed(1)}B`; // Billion
    } else if (num >= 1000000) {
      // 1 million to 999 million
      return `$${(num / 1000000).toFixed(1)}M`; // Million
    } else if (num >= 1000) {
      // 1 thousand to 999 thousand
      return `$${(num / 1000).toFixed(1)}K`; // Thousand
    } else if (num <= -1000) {
      return `$${num.toFixed(1)}K`;
    }
    return `$${num}`; // Less than a thousand
  };
  const revenueRef = useRef();
  const handlePrintDocument = () => {
    const orientation = "portrait";
    printDocument(revenueRef, "Revenue", orientation);
  };
  return (
    <>
      <button
        className="pfdexportIcon"
        onClick={handlePrintDocument}
        title="Download Full Screen"
      >
        <i className="lar la-file-pdf"></i>
      </button>
      <div className="pdfContent" ref={revenueRef}>
        <div className="page-header">
          <div className="row">
            <div className="col-sm-3">
              <h3 className="page-title">Revenue</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Revenue</li>
              </ul>
            </div>
            <div className="col-sm-9">
              <CommonDropdown setGeoShow={setGeoShow} RevenueModule={true} />
            </div>
          </div>
        </div>

        <div className="row seven-cols">
          <div
            className="col-md-1  Widget-hover"
            title="View New Contract Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total New Contract Report",
                  exportFName: "Revenue_NewContract_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "newcontract",
                  showGroup: true,
                  showPeriodGoal: true,
                  PaymentDueDate: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-dollar-sign"></i>{" "}
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.NewContract)}</h3>
                    <span> New</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Existing Contract Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total Existing Contract Report",
                  exportFName: "Revenue_ExistingContract_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "existcontract",
                  showGroup: true,
                  showPeriodGoal: true,
                  PaymentDueDate: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-hand-holding-usd"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.ExistingContract)}</h3>
                    <span> Existing </span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-1  Widget-hover" title="View UpSelling Report">
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total Upselling Report",
                  exportFName: "Revenue_Upselling_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "upselling",
                  showGroup: false,
                  showPeriodGoal: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-funnel-dollar"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.Upselling)}</h3>
                    <span>Upselling</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-1  Widget-hover" title="View RDD Report">
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total RDD Report",
                  exportFName: "Revenue_RDD_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "rdd",
                  showGroup: true,
                  showPeriodGoal: true,
                  PaymentDueDate: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-comment-dollar"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.RDD)}</h3>
                    <span>RDD</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-1  Widget-hover" title="View Over ALL Report">
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total Over All Report",
                  exportFName: "Revenue_OverAll_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "overall",
                  showGroup: true,
                  showPeriodGoal: true,
                  PaymentDueDate: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-comments-dollar"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.Overall)}</h3>
                    <span>Overall</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Scheduled Deposits Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total Scheduled Deposits Report",
                  exportFName: "Revenue_SD_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "scheduleddeposit",
                  showGroup: true,
                  showPeriodGoal: true,
                  PaymentDueDate: false,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-coins"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.Sd)}</h3>
                    <span>SD</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-1  Widget-hover" title="View Deficit Report">
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("RModal");
                modal.style.display = "block";
                var span = document.getElementById("Rclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  title: "Total Deficit Report",
                  exportFName: "Revenue_Deficit_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "deficit",
                  showGroup: true,
                  showPeriodGoal: false,
                  PaymentDueDate: true,
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-trophy"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3>{formatNumberUS(Carddata.Deficit)}</h3>
                    <span>Deficit</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        {!GeoShow && (
          <>
            <div className="row">
              <div className="col-md-6">
                <NewContractChart
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <ExistingContractChart
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <Upselling
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <RevenueRDD
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <OverallChart
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <ScheduledDepositschart
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <RevenueDeficitChart
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
            </div>
          </>
        )}

        {GeoShow && <RevenueMap />}

        {/* <!-- Revenue Report Modal --> */}
        <div id="RModal" class="cmodal">
          <div class="cmodal-content">
            <div className="modal-header">
              <h5 className="modal-title-popup">{reportcolumn.title}</h5>
              <span class="close" id="Rclose">
                &times;
              </span>
            </div>
            <div className="row">
              <div className="col-md-12">
                {reportcolumn.Reportflag && (
                  <KendoGrid
                    exportFileName={reportcolumn.exportFName}
                    name={"Revenue_report"}
                    paggable={true}
                    url={`${baseURL}Analytics/Get_Revenue_ReportData?type=${metrics.type}&years=${year}&filter=${metrics.filter}&metrics=${metrics.metrices}&value=${metrics.metricesValue}&reportType=${reportcolumn.reportvalue}`}
                    schema={{
                      PaymentAmount: { type: "number" },
                    }}
                    refreshWhen={reportcolumn.refreshflag}
                    columns={[
                      {
                        field: "EventNumber",
                        title: "Event No",
                        width: 100,
                      },
                      {
                        field: "EventName",
                        title: "Event Name",
                        width: 150,
                      },
                      {
                        field: "EventType",
                        title: "Event Type",
                        width: 140,
                      },
                      {
                        field: "GuaranteedDate",
                        title: "Guaranteed Date",
                        width: 150,
                      },
                      {
                        field: "ReferralType",
                        title: "Referral Type",
                        width: 150,
                      },
                      {
                        field: "Culture",
                        title: "Culture",
                        width: 150,
                      },
                      {
                        field: "Salesperson",
                        title: "Sales person",
                        width: 110,
                      },
                      {
                        field: "FunctionLocation",
                        title: "Function Location",
                        width: 180,
                      },
                      {
                        field: "PaymentAmount",
                        title: "Payment Amount",
                        width: 160,
                      },
                      {
                        field: "PaymentReceivedDate",
                        title: "Payment Received Date",
                        width: 190,
                      },
                      {
                        field: "PaymentStatus",
                        title: "Payment Status",
                        width: 130,
                      },
                      {
                        field: "PaymentDueDate",
                        title: "Payment DueDate",
                        width: 130,
                        hidden: reportcolumn.PaymentDueDate,
                      },
                      {
                        field: "PaymentType",
                        title: "Payment Type",
                        width: 150,
                      },
                      {
                        field: "SelectedPeriodGoal",
                        title: "Selected Period Goal",
                        width: 180,
                        hidden: reportcolumn.showPeriodGoal,
                      },
                      {
                        field: "Group",
                        title: "Group",
                        width: 200,
                        hidden: reportcolumn.showGroup,
                      },
                    ]}
                    height={400}
                    showOptions={false}
                    showEdit={false}
                    showDelete={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Revenue Report Modal/ --> */}
      </div>
    </>
  );
}
